import {isEmpty, trim} from 'ramda';

import type {SellerResponseBody} from '@dms/api/core';

import type {SellerContact} from '../../../types/SellerContact';

/**
 * Deliberately stricter than RFC 5322 - the value is scraped and goes straight into a `mailto:`
 * link, so characters that start or encode URL parameters (`?`, `&`, `%`, `#`, `=`) must never pass,
 * otherwise a value like `info@dealer.de?bcc=other@example.org` would add a hidden recipient.
 */
const EMAIL_ADDRESS = /^[a-z0-9._+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;

/**
 * Builds the seller e-mail contact with a `mailto:` link.
 *
 * Only a plain e-mail address is linked; anything else is shown as it came, so the link never
 * opens the mail client with a broken or extra recipient.
 */
export function getSellerEmail(seller: SellerResponseBody): SellerContact | null {
  const email = trim(seller.email ?? '');

  if (isEmpty(email)) {
    return null;
  }

  if (!EMAIL_ADDRESS.test(email)) {
    return {label: email};
  }

  return {label: email, href: `mailto:${email}`};
}
